module.exports = __webpack_public_path__ + "img/options.d72a6d87.png";